export const USER_AGGREGATIONS = [
  'joined_users',
  'users_created_real_account',
  'users_created_demo_account',
  'deposited_users',
];

export const getDashboardAggregations = sampleType => [
  ...USER_AGGREGATIONS,
  'total_withdrawals',
  'total_deposits',
  ...(sampleType === 'partner' ? ['traded_volume'] : []),
  'last_kyc_status_change',
];

export const hasMetricData = (data, aggregation) =>
  Object.prototype.hasOwnProperty.call(
    data || {},
    aggregation === 'last_kyc_status_change' ? 'last_kyc_status_change_verified' : aggregation
  );
